'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$MorbidUserDetails(email, account) {
  this.oq = null;
  this.jb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.oq = email;
  this.jb = account;
}
export { $c_Lpresto_types$MorbidUserDetails as $c_Lpresto_types$MorbidUserDetails };
$p = $c_Lpresto_types$MorbidUserDetails.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$MorbidUserDetails;
/** @constructor */
function $h_Lpresto_types$MorbidUserDetails() {
}
export { $h_Lpresto_types$MorbidUserDetails as $h_Lpresto_types$MorbidUserDetails };
$h_Lpresto_types$MorbidUserDetails.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("MorbidUserDetails"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.oq));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.jb;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().br(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$MorbidUserDetails)) {
    if ((this.oq === x$0.oq)) {
      var this$1 = this.jb;
      var b = x$0.jb;
      return ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "MorbidUserDetails";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.oq;
  }
  if ((n === 1)) {
    return this.jb;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$MorbidUserDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jW)));
}
export { $isArrayOf_Lpresto_types$MorbidUserDetails as $isArrayOf_Lpresto_types$MorbidUserDetails };
var $d_Lpresto_types$MorbidUserDetails = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$MorbidUserDetails, "presto.types$MorbidUserDetails", ({
  jW: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$MorbidUserDetails as $d_Lpresto_types$MorbidUserDetails };
//# sourceMappingURL=presto.types$-Morbid-User-Details.js.map
